import { LitElement, css, html } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'

@customElement('ep-timeline-item')
export class EPTimelineItem extends LitElement {

  @property({ attribute: false })
  showBadge: boolean = false;

  @property({ attribute: false })
  showAvatar: boolean = false;

  @query('slot[name=badge]')
  badgeSlot?: HTMLSlotElement;

  @query('slot[name=avatar]')
  avatarSlot?: HTMLSlotElement;

  private _handleBadgeSlotChange(event: Event) {
    this.showBadge = (this.badgeSlot?.assignedNodes()?.length ?? 0) > 0;
  }

  private _handleAvatarSlotChange(event: Event) {
    this.showAvatar = (this.avatarSlot?.assignedNodes()?.length ?? 0) > 0;;
  }
  
  render() {
    return html`
      <div class="timeline-item">
        <div class="timeline-item-badge" style=${!this.showBadge ? 'display: none;' : ''}>
          <slot name="badge" @slotchange=${this._handleBadgeSlotChange}>
            <!--<ep-status-badge style="--size: 32px;" icon="unknown"></ep-status-badge>-->
          </slot>
        </div>
        <div class="timeline-item-avatar" style=${!this.showAvatar ? 'display: none;' : ''}>
          <slot name="avatar" @slotchange=${this._handleAvatarSlotChange}>
            <!--<ep-status-badge style="--size: 40px;" icon="unknown"></ep-status-badge>-->
          </slot>
        </div>
        <div class="timeline-item-body">
          <slot>
            <!--<a href="#">Monalisa created one hot potato Just now</a>-->
          </slot>
        </div>
        <slot name="trailing"></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      --text-default: rgb(31, 35, 40);
      --text-muted: rgb(101, 109, 118);
      --border-muted: rgb(216, 222, 228);
      --border-default: rgb(208, 215, 222);
      --badge-background: rgb(234, 238, 242);
      --canvas-subtle: rgb(246, 248, 250);
    }

    .timeline-item {
      display: flex;
      position: relative;
      padding: 16px 0px;
      margin-left: 16px;
    }

    .timeline-item::before {
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      display: block;
      width: 2px;
      content: "";
      background-color: var(--border-muted);
    }

    .timeline-item-badge {
      position: relative;
      z-index: 1;
    }

    .timeline-item-avatar {
      left: -72px;
      position: absolute;
      z-index: 1;
    }

    .timeline-item-badge * {
      margin-right: 8px;
      margin-left: -15px;
      color: var(--text-muted);
      background-color: var(--badge-background);
      display: flex;
      overflow: hidden;
      width: 32px;
      height: 32px;
      flex-shrink: 0;
      -moz-box-align: center;
      align-items: center;
      -moz-box-pack: center;
      justify-content: center;
      border-radius: 50%;
      border-width: 2px;
      border-style: solid;
      border-color: rgb(255, 255, 255);
    }

    .timeline-item-body {
      min-width: 0px;
      max-width: 100%;
      margin-top: 4px;
      color: var(--text-muted);
      flex: 1 1 auto;
      font-size: 14px;
      line-height: 1.5;
    }

    ::slotted(strong) {
      color: var(--text-default);
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-timeline-item': EPTimelineItem
  }
}
